<!-- mettal-3\src\components\X6.vue -->
<template>
  <div :class="[`view-185-item-1-1`, className || ``]">
    <img
      class="image-20"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/---------------21@2x.png"
      alt="image"
    />
    <view702 :x01="view70Props.x01" />
  </div>
</template>

<script>
import View702 from "./View702";
export default {
  name: "X6",
  components: {
    View702,
  },
  props: ["className", "view70Props"],
};
</script>

<style>
.view-185-item-1-1 {
  background-color: var(--storm-dust-2);
  border-radius: 12px;
  height: 90px;
  margin-left: 4px;
  margin-top: 12px;
  position: relative;
  width: 300px;
}

.image-20 {
  height: 86px;
  left: 4px;
  position: absolute;
  top: 3px;
  width: 293px;
}

.view-185-item-1-1.view-item-2 {
  margin-left: 5px;
}
</style>
